import React from "react";
import DialogCloseButton from "../buttons/DialogCloseButton";
import QrCodeCard from "../cards/QrCodeCard";

interface QrCodeDialogProps {
    open: boolean;
    code: string;
    codeType: string;
    qrDestinationPage: string;
    onClose: () => void;
}

export default function QrCodeDialog({open, code, codeType, qrDestinationPage, onClose}: QrCodeDialogProps) {
    if (!open) return null;

    return (
        <div className="dialog-overlay">
            <div className="dialog">
                <DialogCloseButton onClose={onClose}/>

                <h3>QR‑Code</h3>

                <QrCodeCard code={code} codeType={codeType} qrDestinationPage={qrDestinationPage}/>
            </div>
        </div>
    );
}